import React from "react"
import PropTypes from "prop-types"
import classnames from 'classnames/bind'

import LoadingBlock from "js/components/shared/LoadingBlock"

import styles from './SectionLoader.module.scss'

const cx = classnames.bind(styles)

const SectionLoader = ({ className = '', columnClassName = '' }) => (
  <div className={cx("root", className)}>
    <div className={cx('column', columnClassName)}>
      <LoadingBlock style={{display: "inline-block", height: "50px"}}/>
    </div>
    <div className={cx('column', columnClassName)}>
      <LoadingBlock style={{display: "inline-block", height: "50px"}}/>
    </div>
    <div className={cx('column', columnClassName)}>
      <LoadingBlock style={{display: "inline-block", height: "50px"}}/>
    </div>
  </div>
)

SectionLoader.propTypes = {
  className: PropTypes.string,
  columnClassName: PropTypes.string
}

export default SectionLoader
